import { render, staticRenderFns } from "./CompanyEditVars.vue?vue&type=template&id=57d5c6e1&"
import script from "./CompanyEditVars.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditVars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d5c6e1')) {
      api.createRecord('57d5c6e1', component.options)
    } else {
      api.reload('57d5c6e1', component.options)
    }
    module.hot.accept("./CompanyEditVars.vue?vue&type=template&id=57d5c6e1&", function () {
      api.rerender('57d5c6e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditVars.vue"
export default component.exports